import BiMap from 'bidirectional-map';
import { SizingKitProductShopifyMap as RingAirSizingKitProductShopifyMap } from 'content/products/accessories/SizingKitProductShopifyMap';
import { buildStoreConfig } from 'content/products/storeAliasHelper';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

//change

export { RingType, getEngravingKey, AirRingColors, RingSizes } from './enums';
export { RingPriceData, MiscRingCheckoutTypes } from './enums';
export type { RingVariantType } from './enums';
export {
  DISABLED_RING_AIR_SKUS,
  ringAirSkuRuleMatches,
  isRingAirSkuDisabled,
  isRingAirColorDisabled,
  getAvailableAirRingColors,
  FrontendBackendRingNameMap,
  resolveAirRingColorParam,
  WSFrontendBackendRingNameMap,
  FrontendBackendRingNameMapWithDefault,
  WSFrontendBackendRingNameMapWithDefault,
} from './enums';
export type { DisabledRingAirSkuRule, RingAirSkuQuery } from './enums';
import { RingType, AirRingColors, RingSizes } from './enums';

// OG Prices
// export const RingPrice: Record<RingCurrency, number> = {
//   [ShopifyStore.IN]: 28_499,
//   [ShopifyStore.ROW]: 349,
//   [ShopifyStore.AE]: 1299,
// };

export const EngravingPrice: Record<ShopifyStore, number> = {
  [ShopifyStore.IN]: 3_299,
  [ShopifyStore.ROW]: 39,
  [ShopifyStore.US]: 39,
  [ShopifyStore.AE]: 149,
  [ShopifyStore.EU]: 30,
  [ShopifyStore.GB]: 36,
  [ShopifyStore.AU]: 59,
  [ShopifyStore.CA]: 54,
  [ShopifyStore.SA]: 169,
  [ShopifyStore.MX]: 728,
  [ShopifyStore.ZA]: 1000,
  [ShopifyStore.JP]: 6000,
};

export const RoseGoldPrice: Record<ShopifyStore, number> = {
  [ShopifyStore.IN]: 5_500,
  [ShopifyStore.ROW]: 50,
  [ShopifyStore.US]: 50,
  [ShopifyStore.AE]: 190,
  [ShopifyStore.EU]: 55,
  [ShopifyStore.GB]: 50,
  [ShopifyStore.AU]: 100,
  [ShopifyStore.CA]: 70,
  [ShopifyStore.SA]: 220,
  [ShopifyStore.MX]: 1000,
  [ShopifyStore.ZA]: 1000,
  [ShopifyStore.JP]: 9000,
};

export const RingPriceStriked: Record<
  RingType,
  Record<ShopifyStore, number>
> = {
  [RingType.ENGRAVED]: {
    [ShopifyStore.IN]: 31_798,
    [ShopifyStore.ROW]: 388,
    [ShopifyStore.US]: 388,
    [ShopifyStore.AE]: 1448,
    [ShopifyStore.EU]: 409,
    [ShopifyStore.GB]: 365,
    [ShopifyStore.AU]: 653,
    [ShopifyStore.CA]: 533,
    [ShopifyStore.SA]: 1949,
    [ShopifyStore.MX]: 7627,
    [ShopifyStore.ZA]: 8999,
    [ShopifyStore.JP]: 65800,
  },
  [RingType.NOT_ENGRAVED]: {
    [ShopifyStore.IN]: 28_499,
    [ShopifyStore.ROW]: 349,
    [ShopifyStore.US]: 349,
    [ShopifyStore.AE]: 1299,
    [ShopifyStore.EU]: 379,
    [ShopifyStore.GB]: 329,
    [ShopifyStore.AU]: 599,
    [ShopifyStore.CA]: 479,
    [ShopifyStore.SA]: 1509,
    [ShopifyStore.MX]: 6899,
    [ShopifyStore.ZA]: 7999,
    [ShopifyStore.JP]: 59800,
  },
};

export const RoseGoldPriceStriked: Record<ShopifyStore, number> = {
  [ShopifyStore.IN]: 5_500,
  [ShopifyStore.ROW]: 50,
  [ShopifyStore.US]: 50,
  [ShopifyStore.AE]: 190,
  [ShopifyStore.EU]: 55,
  [ShopifyStore.GB]: 50,
  [ShopifyStore.AU]: 100,
  [ShopifyStore.CA]: 70,
  [ShopifyStore.SA]: 220,
  [ShopifyStore.MX]: 1000,
  [ShopifyStore.ZA]: 1000,
  [ShopifyStore.JP]: 9000,
};

export const DEFAULT_PRICE_STRIKED_STORES: Array<ShopifyStore> = [
  // ShopifyStore.IN,
  // ShopifyStore.ROW,
  // ShopifyStore.US,
  // ShopifyStore.AE,
  // ShopifyStore.EU,
  // ShopifyStore.GB,
];

type TFunction = (key: string) => string;

export const getRingAirColorNameImages = (
  t: TFunction,
): Record<AirRingColors, Record<string, string | null | React.ReactNode>> => ({
  [AirRingColors.RAW_TITANIUM]: {
    shop: `web_v2/shop/air-1/raw-titanium.png`,
    image: 'web_v2/ring-buy/color-cta/rt-3.png/w_400',
    swatch: 'web_v2/ring-buy/ring-air-color-swatch/raw-titanium.png',
    name: t('ring.productSelection.RAW_TITANIUM'),
    tag: null,
  },
  [AirRingColors.ASTER_BLACK]: {
    shop: `web_v2/shop/air-1/aster-black.png`,
    image: 'web_v2/ring-buy/color-cta/ab-3.png/w_400',
    swatch: 'web_v2/ring-buy/ring-air-color-swatch/aster-black.png',
    name: t('ring.productSelection.ASTER_BLACK'),
    tag: null,
  },
  [AirRingColors.MATTE_GREY]: {
    shop: `web_v2/shop/air-1/matte-grey.png`,
    image: 'web_v2/ring-buy/color-cta/mg-3.png/w_400',
    swatch: 'web_v2/ring-buy/ring-air-color-swatch/matte-grey.png',
    name: t('ring.productSelection.MATTE_GREY'),
    tag: null,
  },
  [AirRingColors.BIONIC_GOLD]: {
    shop: `web_v2/shop/air-1/bionic-gold.png`,
    image: 'web_v2/ring-buy/color-cta/bg-3.png/w_400',
    swatch: 'web_v2/ring-buy/ring-air-color-swatch/bionic-gold.png',
    name: t('ring.productSelection.BIONIC_GOLD'),
    tag: null,
  },
  [AirRingColors.SPACE_SILVER]: {
    shop: `web_v2/shop/air-1/space-silver.png`,
    image: 'web_v2/ring-buy/color-cta/ss-3.png/w_400',
    swatch: 'web_v2/ring-buy/ring-air-color-swatch/space-silver.png',
    name: t('ring.productSelection.SPACE_SILVER'),
    tag: null,
  },
  [AirRingColors.ROSE_GOLD]: {
    shop: `web_v2/shop/air-1/brushed-rose-gold.png`,
    image: 'web_v2/ring-buy/color-cta/rg-5.png/w_400',
    swatch: 'web_v2/ring-buy/ring-air-color-swatch/rose-gold.png',
    name: t('ring.productSelection.ROSE_GOLD'),
    tag: null,
  },
});

export const RingAirColorTagOverrides: Partial<
  Record<
    ShopifyStore,
    Partial<Record<AirRingColors, string | React.ReactNode | null>>
  >
> = {
  [ShopifyStore.US]: {
    [AirRingColors.RAW_TITANIUM]: null,
  },
};

export const getRingAirColorTag = (
  color: AirRingColors,
  store?: ShopifyStore | null,
  t?: TFunction,
): string | React.ReactNode | null => {
  // Use a fallback identity function if t is not provided
  const defaultT: TFunction = (key) => key;
  const RingAirColorNameImages = getRingAirColorNameImages(t || defaultT);
  const defaultTag = RingAirColorNameImages[color]?.tag ?? null;

  if (!store) {
    return defaultTag ?? null;
  }

  const overrides = RingAirColorTagOverrides[store];

  if (overrides && Object.prototype.hasOwnProperty.call(overrides, color)) {
    return overrides[color] ?? null;
  }

  return defaultTag ?? null;
};

export const RingAirColorNameLargeImages: Record<
  AirRingColors,
  Record<string, string | null>
> = {
  [AirRingColors.RAW_TITANIUM]: {
    image: 'web_v2/ring-buy/color-cta/rt-3.png/w_1000',
    name: 'Raw Titanium',
    tag: null,
  },
  [AirRingColors.ASTER_BLACK]: {
    image: 'web_v2/ring-buy/color-cta/ab-3.png/w_1000',
    name: 'Aster Black',
    tag: null,
  },
  [AirRingColors.MATTE_GREY]: {
    image: 'web_v2/ring-buy/color-cta/mg-3.png/w_1000',
    name: 'Matte Grey',
    tag: null,
  },
  [AirRingColors.BIONIC_GOLD]: {
    image: 'web_v2/ring-buy/color-cta/bg-3.png/w_1000',
    name: 'Bionic Gold',
    tag: null,
  },
  [AirRingColors.SPACE_SILVER]: {
    image: 'web_v2/ring-buy/color-cta/ss-3.png/w_1000',
    name: 'Space Silver',
    tag: null,
  },
  [AirRingColors.ROSE_GOLD]: {
    image: 'web_v2/ring-buy/color-cta/rg-5.png/w_1000',
    name: 'Brushed Rose Gold',
    tag: null,
  },
};

/**
 * Purchase-code `shopify_store` ids ↔ frontend stores. Only consumer:
 * `resolveStore()` in utils/ring-claim/purchaseCode.ts (the claim pages).
 *
 * Backend confirmed the full id set on 2026-09-28: stelcore, us, eu_uk,
 * india, uae. The ids name Shopify ACCOUNTS, not markets — `stelcore` is
 * stelcore-x-ultrahuman (the US store, always) and `us` is ultrahuman-us
 * (the global store). Verify against a real API response, never the name.
 *
 * BiMap enforces 1:1 by silently DELETING the earlier key on a duplicate
 * value: GB's 'eu_uk' row evicts EU's, so getKey('eu_uk') returns GB and
 * resolveStore()'s ipCountry branch supplies EU. Mind this when editing.
 */
export const FrontendBackendStoresMap = new BiMap({
  [ShopifyStore.IN]: 'india',
  [ShopifyStore.AE]: 'uae',
  [ShopifyStore.EU]: 'eu_uk',
  [ShopifyStore.GB]: 'eu_uk',
  [ShopifyStore.US]: 'stelcore',
  [ShopifyStore.ROW]: 'us',
});

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

export enum RingChargerType {
  OG = 'OG',
  DARK_MOON = 'DARK_MOON',
  TRAVEL_CHARGER = 'TRAVEL_CHARGER',
}

//ask if we can remove this
export const TravelChargerShopifyMap = {
  [ShopifyStore.IN]: {
    price: 3_799,
    [RingSizes.FIVE]: {
      variantId: '41655339319366',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655339319366',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655339319366:1',
    },
    [RingSizes.SIX]: {
      variantId: '41655339581510',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655339581510',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655339581510:1',
    },
    [RingSizes.SEVEN]: {
      variantId: '41655339876422',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655339876422',
      checkoutUrl: 'https://ultrahumanstore.myshopify.com/cart/7521922023494:1',
    },
    [RingSizes.EIGHT]: {
      variantId: '41655340171334',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655340171334',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655340171334:1',
    },
    [RingSizes.NINE]: {
      variantId: '41655340400710',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655340400710',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655340400710:1',
    },
    [RingSizes.TEN]: {
      variantId: '41655340630086',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655340630086',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655340630086:1',
    },
    [RingSizes.ELEVEN]: {
      variantId: '41655340924998',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655340924998',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655340924998:1',
    },
    [RingSizes.TWELVE]: {
      variantId: '41655341154374',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655341154374',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655341154374:1',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '41655341482054',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655341482054',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655341482054:1',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '41655341711430',
      shopifyVariantId: 'gid://shopify/ProductVariant/41655341711430',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41655341711430:1',
    },
    [RingSizes.OPEN]: {
      variantId: '41662070980678',
      shopifyVariantId: 'gid://shopify/ProductVariant/41662070980678',
      checkoutUrl:
        'https://ultrahumanstore.myshopify.com/cart/41662070980678:1',
    },
  },
  [ShopifyStore.AE]: {
    price: 169,
    [RingSizes.FIVE]: {
      variantId: '45975073292530',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975073292530',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975073292530:1',
    },
    [RingSizes.SIX]: {
      variantId: '45975073489138',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975073489138',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975073489138:1',
    },
    [RingSizes.SEVEN]: {
      variantId: '45975073685746',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975073685746',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975073685746:1',
    },
    [RingSizes.EIGHT]: {
      variantId: '45975073882354',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975073882354',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975073882354:1',
    },
    [RingSizes.NINE]: {
      variantId: '45975074078962',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975074078962',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975074078962:1',
    },
    [RingSizes.TEN]: {
      variantId: '45975074275570',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975074275570',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975074275570:1',
    },
    [RingSizes.ELEVEN]: {
      variantId: '45975074472178',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975074472178',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975074472178:1',
    },
    [RingSizes.TWELVE]: {
      variantId: '45975074668786',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975074668786',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975074668786:1',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '45975074865394',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975074865394',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975074865394:1',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '45975075062002',
      shopifyVariantId: 'gid://shopify/ProductVariant/45975075062002',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45975075062002:1',
    },
    [RingSizes.OPEN]: {
      variantId: '45988381950194',
      shopifyVariantId: 'gid://shopify/ProductVariant/45988381950194',
      checkoutUrl:
        'https://ultrahuman-mena.myshopify.com/cart/45988381950194:1',
    },
  },
  [ShopifyStore.US]: {
    price: 45,
    [RingSizes.FIVE]: {
      variantId: '40810822762592',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822762592',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822762592:1',
    },
    [RingSizes.SIX]: {
      variantId: '40810822795360',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822795360',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822795360:1',
    },
    [RingSizes.SEVEN]: {
      variantId: '40810822828128',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822828128',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822828128:1',
    },
    [RingSizes.EIGHT]: {
      variantId: '40810822860896',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822860896',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822860896:1',
    },
    [RingSizes.NINE]: {
      variantId: '40810822893664',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822893664',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822893664:1',
    },
    [RingSizes.TEN]: {
      variantId: '40810822926432',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822926432',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822926432:1',
    },
    [RingSizes.ELEVEN]: {
      variantId: '40810822959200',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822959200',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822959200:1',
    },
    [RingSizes.TWELVE]: {
      variantId: '40810822991968',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822991968',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822991968:1',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '40810823024736',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810823024736',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810823024736:1',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '40810823057504',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810823057504',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810823057504:1',
    },
    [RingSizes.OPEN]: {
      variantId: '40818980356192',
      shopifyVariantId: 'gid://shopify/ProductVariant/40818980356192',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40818980356192:1',
    },
  },
  [ShopifyStore.ROW]: {
    price: 45,
    [RingSizes.FIVE]: {
      variantId: '41619116523580',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619116523580',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619116523580:1',
    },
    [RingSizes.SIX]: {
      variantId: '41619116720188',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619116720188',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619116720188:1',
    },
    [RingSizes.SEVEN]: {
      variantId: '41619116916796',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619116916796',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619116916796:1',
    },
    [RingSizes.EIGHT]: {
      variantId: '41619117113404',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619117113404',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619117113404:1',
    },
    [RingSizes.NINE]: {
      variantId: '41619117310012',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619117310012',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619117310012:1',
    },
    [RingSizes.TEN]: {
      variantId: '41619117506620',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619117506620',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619117506620:1',
    },
    [RingSizes.ELEVEN]: {
      variantId: '41619117703228',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619117703228',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619117703228:1',
    },
    [RingSizes.TWELVE]: {
      variantId: '41619117899836',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619117899836',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619117899836:1',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '41619118096444',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619118096444',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619118096444:1',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '41619118293052',
      shopifyVariantId: 'gid://shopify/ProductVariant/41619118293052',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41619118293052:1',
    },
    [RingSizes.OPEN]: {
      variantId: '41630148132924',
      shopifyVariantId: 'gid://shopify/ProductVariant/41630148132924',
      checkoutUrl: 'https://ultrahuman-us.myshopify.com/cart/41630148132924:1',
    },
  },
  [ShopifyStore.EU]: {
    price: 42,
    [RingSizes.FIVE]: {
      variantId: '49621428109630',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428109630',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428109630:1?channel=buy_button',
    },
    [RingSizes.SIX]: {
      variantId: '49621428273470',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428273470',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428273470:1?channel=buy_button',
    },
    [RingSizes.SEVEN]: {
      variantId: '49621428437310',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428437310',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428437310:1?channel=buy_button',
    },
    [RingSizes.EIGHT]: {
      variantId: '49621428699454',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428699454',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428699454:1?channel=buy_button',
    },
    [RingSizes.NINE]: {
      variantId: '49621429190974',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429190974',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429190974:1?channel=buy_button',
    },
    [RingSizes.TEN]: {
      variantId: '49621429551422',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429551422',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429551422:1?channel=buy_button',
    },
    [RingSizes.ELEVEN]: {
      variantId: '49621429715262',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429715262',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429715262:1?channel=buy_button',
    },
    [RingSizes.TWELVE]: {
      variantId: '49621429879102',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429879102',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429879102:1?channel=buy_button',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '49621430042942',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621430042942',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621430042942:1?channel=buy_button',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '49621430206782',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621430206782',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621430206782:1?channel=buy_button',
    },
    [RingSizes.OPEN]: {
      variantId: '49633970487614',
      shopifyVariantId: 'gid://shopify/ProductVariant/49633970487614',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49633970487614:1?channel=buy_button',
    },
  },
  [ShopifyStore.GB]: {
    price: 39,
    [RingSizes.FIVE]: {
      variantId: '49621428109630',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428109630',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428109630:1?channel=buy_button',
    },
    [RingSizes.SIX]: {
      variantId: '49621428273470',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428273470',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428273470:1?channel=buy_button',
    },
    [RingSizes.SEVEN]: {
      variantId: '49621428437310',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428437310',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428437310:1?channel=buy_button',
    },
    [RingSizes.EIGHT]: {
      variantId: '49621428699454',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428699454',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428699454:1?channel=buy_button',
    },
    [RingSizes.NINE]: {
      variantId: '49621429190974',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429190974',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429190974:1?channel=buy_button',
    },
    [RingSizes.TEN]: {
      variantId: '49621429551422',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429551422',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429551422:1?channel=buy_button',
    },
    [RingSizes.ELEVEN]: {
      variantId: '49621429715262',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429715262',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429715262:1?channel=buy_button',
    },
    [RingSizes.TWELVE]: {
      variantId: '49621429879102',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429879102',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429879102:1?channel=buy_button',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '49621430042942',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621430042942',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621430042942:1?channel=buy_button',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '49621430206782',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621430206782',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621430206782:1?channel=buy_button',
    },
    [RingSizes.OPEN]: {
      variantId: '49633970487614',
      shopifyVariantId: 'gid://shopify/ProductVariant/49633970487614',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49633970487614:1?channel=buy_button',
    },
  },
  [ShopifyStore.AU]: {
    price: 69,
    [RingSizes.FIVE]: {
      variantId: '49621428109630',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428109630',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428109630:1?channel=buy_button',
    },
    [RingSizes.SIX]: {
      variantId: '49621428273470',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428273470',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428273470:1?channel=buy_button',
    },
    [RingSizes.SEVEN]: {
      variantId: '49621428437310',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428437310',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428437310:1?channel=buy_button',
    },
    [RingSizes.EIGHT]: {
      variantId: '49621428699454',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621428699454',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621428699454:1?channel=buy_button',
    },
    [RingSizes.NINE]: {
      variantId: '49621429190974',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429190974',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429190974:1?channel=buy_button',
    },
    [RingSizes.TEN]: {
      variantId: '49621429551422',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429551422',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429551422:1?channel=buy_button',
    },
    [RingSizes.ELEVEN]: {
      variantId: '49621429715262',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429715262',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429715262:1?channel=buy_button',
    },
    [RingSizes.TWELVE]: {
      variantId: '49621429879102',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621429879102',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621429879102:1?channel=buy_button',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '49621430042942',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621430042942',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621430042942:1?channel=buy_button',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '49621430206782',
      shopifyVariantId: 'gid://shopify/ProductVariant/49621430206782',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49621430206782:1?channel=buy_button',
    },
    [RingSizes.OPEN]: {
      variantId: '49633970487614',
      shopifyVariantId: 'gid://shopify/ProductVariant/49633970487614',
      checkoutUrl:
        'https://ultrahuman-eu-uk.myshopify.com/cart/49633970487614:1?channel=buy_button',
    },
  },
  [ShopifyStore.CA]: {
    price: 69,
    [RingSizes.FIVE]: {
      variantId: '40810822762592',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822762592',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822762592:1',
    },
    [RingSizes.SIX]: {
      variantId: '40810822795360',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822795360',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822795360:1',
    },
    [RingSizes.SEVEN]: {
      variantId: '40810822828128',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822828128',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822828128:1',
    },
    [RingSizes.EIGHT]: {
      variantId: '40810822860896',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822860896',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822860896:1',
    },
    [RingSizes.NINE]: {
      variantId: '40810822893664',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822893664',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822893664:1',
    },
    [RingSizes.TEN]: {
      variantId: '40810822926432',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822926432',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822926432:1',
    },
    [RingSizes.ELEVEN]: {
      variantId: '40810822959200',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822959200',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822959200:1',
    },
    [RingSizes.TWELVE]: {
      variantId: '40810822991968',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810822991968',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822991968:1',
    },
    [RingSizes.THIRTEEN]: {
      variantId: '40810823024736',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810823024736',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810823024736:1',
    },
    [RingSizes.FOURTEEN]: {
      variantId: '40810823057504',
      shopifyVariantId: 'gid://shopify/ProductVariant/40810823057504',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40810823057504:1',
    },
    [RingSizes.OPEN]: {
      variantId: '40818980356192',
      shopifyVariantId: 'gid://shopify/ProductVariant/40818980356192',
      checkoutUrl:
        'https://stelcore-x-ultrahuman.myshopify.com/cart/40818980356192:1',
    },
  },
};

export const DarkMoonChargerShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? {
      [ShopifyStore.IN]: {
        price: 3_999,
        variantId: '40682321805382',
        shopifyVariantId: 'gid://shopify/ProductVariant/40682321805382',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/40682321805382:1',
      },
      [ShopifyStore.ROW]: {
        price: 45,
        variantId: '40682739564604',
        shopifyVariantId: 'gid://shopify/ProductVariant/40682739564604',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40682739564604:1',
      },
      [ShopifyStore.US]: {
        //replace when activating dark moon charger again
        price: 45,
        variantId: '40682739564604',
        shopifyVariantId: 'gid://shopify/ProductVariant/40682739564604',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40682739564604:1',
      },
      [ShopifyStore.EU]: {
        //replace when activating dark moon charger again
        price: 45,
        variantId: '40682739564604',
        shopifyVariantId: 'gid://shopify/ProductVariant/40682739564604',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40682739564604:1',
      },
      [ShopifyStore.GB]: {
        //replace when activating dark moon charger again
        price: 45,
        variantId: '40682739564604',
        shopifyVariantId: 'gid://shopify/ProductVariant/40682739564604',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40682739564604:1',
      },
      [ShopifyStore.AE]: {
        price: 169,
        variantId: '44628151140594',
        shopifyVariantId: 'gid://shopify/ProductVariant/44628151140594',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/44628151140594:1',
      },
      // FIXME: Need prices for this
      [ShopifyStore.AU]: {
        price: 59,
        variantId: '49621428109630',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621428109630',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621428109630:1',
      },
      [ShopifyStore.CA]: {
        price: 49,
        variantId: '40810822762592',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822762592',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822762592:1',
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: { price: 749 },
      [ShopifyStore.JP]: { price: 6980 },
    }
  : {
      [ShopifyStore.IN]: {
        price: 3_999,
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl: 'https://uhtesting.myshopify.com/cart/40570026983497:1',
      },
      [ShopifyStore.ROW]: {
        price: 45,
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl: 'https://uhtesting.myshopify.com/cart/40570026983497:1',
      },
      [ShopifyStore.US]: {
        price: 45,
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl: 'https://uhtesting.myshopify.com/cart/40570026983497:1',
      },
      [ShopifyStore.EU]: {
        price: 45,
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl: 'https://uhtesting.myshopify.com/cart/40570026983497:1',
      },
      [ShopifyStore.GB]: {
        //replace when activating dark moon charger again
        price: 45,
        variantId: '40682739564604',
        shopifyVariantId: 'gid://shopify/ProductVariant/40682739564604',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40682739564604:1',
      },
      [ShopifyStore.AE]: {
        price: 169,
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl: 'https://uhtesting.myshopify.com/cart/40570026983497:1',
      },
      // FIXME: Need prices for this
      [ShopifyStore.AU]: {
        price: 59,
        variantId: '49621428109630',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621428109630',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621428109630:1',
      },
      [ShopifyStore.CA]: {
        price: 49,
        variantId: '40810822762592',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822762592',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822762592:1',
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: { price: 749 },
      [ShopifyStore.JP]: { price: 6980 },
    };

export const CgmPatchesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 799,
    variantId: '40728732565574',
    shopifyVariantId: 'gid://shopify/ProductVariant/40728732565574',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/40728732565574:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 29,
    variantId: '40718030110780',
    shopifyVariantId: 'gid://shopify/ProductVariant/40718030110780',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/40718030110780:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 29,
    variantId: '40200415477856',
    shopifyVariantId: 'gid://shopify/ProductVariant/40200415477856',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/40200415477856:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 119,
    variantId: '44690781733106',
    shopifyVariantId: 'gid://shopify/ProductVariant/44690781733106',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/44690781733106:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 29,
    variantId: '49202716901694',
    shopifyVariantId: 'gid://shopify/ProductVariant/49202716901694',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/49202716901694:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 15,
    variantId: '49202716901694',
    shopifyVariantId: 'gid://shopify/ProductVariant/49202716901694',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/49202716901694:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 29,
    variantId: '49202716901694',
    shopifyVariantId: 'gid://shopify/ProductVariant/49202716901694',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/49202716901694:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 49,
    variantId: '40200415477856',
    shopifyVariantId: 'gid://shopify/ProductVariant/40200415477856',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/40200415477856:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 129,
  },
  [ShopifyStore.MX]: {
    price: 502,
  },
  [ShopifyStore.ZA]: {
    price: 599,
  },
  [ShopifyStore.JP]: {
    price: 5400,
  },
};

export const dayBlackGlassesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 7999,
    variantId: '42330065535046',
    shopifyVariantId: 'gid://shopify/ProductVariant/42330065535046',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/42330065535046:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 99,
    variantId: '42378356686908',
    shopifyVariantId: 'gid://shopify/ProductVariant/42378356686908',
    checkoutUrl:
      'https://ultrahuman-us.myshopify.com/cart/42378356686908:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 99,
    variantId: '41453041975392',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453041975392',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453041975392:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 355,
    variantId: '51986382324083',
    shopifyVariantId: 'gid://shopify/ProductVariant/51986382324083',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/51986382324083:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 91,
    variantId: '54831405465974',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831405465974',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831405465974:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 79,
    variantId: '54831405465974',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831405465974',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831405465974:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 169,
    variantId: '54831405465974',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831405465974',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831405465974:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 149,
    variantId: '41453041975392',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453041975392',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453041975392:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 429,
  },
  [ShopifyStore.MX]: {
    price: 2031,
  },
  [ShopifyStore.ZA]: {
    price: 999,
  },
  [ShopifyStore.JP]: {
    price: 13800,
  },
};

export const dayTransparentGlassesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 7999,
    variantId: '42330065567814',
    shopifyVariantId: 'gid://shopify/ProductVariant/42330065567814',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/42330065567814:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 99,
    variantId: '42378356654140',
    shopifyVariantId: 'gid://shopify/ProductVariant/42378356654140',
    checkoutUrl:
      'https://ultrahuman-us.myshopify.com/cart/42378356654140:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 99,
    variantId: '41453042008160',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453042008160',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453042008160:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 355,
    variantId: '51986382291315',
    shopifyVariantId: 'gid://shopify/ProductVariant/51986382291315',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/51986382291315:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 91,
    variantId: '54831405498742',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831405498742',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831405498742:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 79,
    variantId: '54831405498742',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831405498742',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831405498742:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 169,
    variantId: '54831405498742',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831405498742',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831405498742:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 149,
    variantId: '41453042008160',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453042008160',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453042008160:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 429,
  },
  [ShopifyStore.MX]: {
    price: 2031,
  },
  [ShopifyStore.ZA]: {
    price: 999,
  },
  [ShopifyStore.JP]: {
    price: 13800,
  },
};

export const nightBlackGlassesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 7999,
    variantId: '42330063700038',
    shopifyVariantId: 'gid://shopify/ProductVariant/42330063700038',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/42330063700038:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 99,
    variantId: '42378340663356',
    shopifyVariantId: 'gid://shopify/ProductVariant/42378340663356',
    checkoutUrl:
      'https://ultrahuman-us.myshopify.com/cart/42378340663356:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 99,
    variantId: '41453041483872',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453041483872',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453041483872:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 355,
    variantId: '51986380521843',
    shopifyVariantId: 'gid://shopify/ProductVariant/51986380521843',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/51986380521843:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 91,
    variantId: '54831400976758',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831400976758',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831400976758:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 79,
    variantId: '54831400976758',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831400976758',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831400976758:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 169,
    variantId: '54831400976758',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831400976758',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831400976758:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 149,
    variantId: '41453041483872',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453041483872',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453041483872:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 429,
  },
  [ShopifyStore.MX]: {
    price: 2031,
  },
  [ShopifyStore.ZA]: {
    price: 999,
  },
  [ShopifyStore.JP]: {
    price: 13800,
  },
};

export const nightTransparentGlassesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 7999,
    variantId: '42330063732806',
    shopifyVariantId: 'gid://shopify/ProductVariant/42330063732806',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/42330063732806:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 99,
    variantId: '42378340630588',
    shopifyVariantId: 'gid://shopify/ProductVariant/42378340630588',
    checkoutUrl:
      'https://ultrahuman-us.myshopify.com/cart/42378340630588:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 99,
    variantId: '41453041516640',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453041516640',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453041516640:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 355,
    variantId: '51986380489075',
    shopifyVariantId: 'gid://shopify/ProductVariant/51986380489075',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/51986380489075:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 91,
    variantId: '54831401009526',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831401009526',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831401009526:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 79,
    variantId: '54831401009526',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831401009526',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831401009526:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 169,
    variantId: '54831401009526',
    shopifyVariantId: 'gid://shopify/ProductVariant/54831401009526',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54831401009526:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 149,
    variantId: '41453041516640',
    shopifyVariantId: 'gid://shopify/ProductVariant/41453041516640',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/41453041516640:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 429,
  },
  [ShopifyStore.MX]: {
    price: 2031,
  },
  [ShopifyStore.ZA]: {
    price: 999,
  },
  [ShopifyStore.JP]: {
    price: 13800,
  },
};

export const SleepMaskShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 3290,
    variantId: '40946872746054',
    shopifyVariantId: 'gid://shopify/ProductVariant/40946872746054',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/40946872746054:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 39,
    variantId: '40911838183484',
    shopifyVariantId: 'gid://shopify/ProductVariant/40911838183484',
    checkoutUrl:
      'https://ultrahuman-us.myshopify.com/cart/40911838183484:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 39,
    variantId: '40200381038688',
    shopifyVariantId: 'gid://shopify/ProductVariant/40200381038688',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/40200381038688:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 150,
    variantId: '45034593812722',
    shopifyVariantId: 'gid://shopify/ProductVariant/45034593812722',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/45034593812722:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 35,
    variantId: '49202074190142',
    shopifyVariantId: 'gid://shopify/ProductVariant/49202074190142',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/49202074190142:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 29,
    variantId: '49202074190142',
    shopifyVariantId: 'gid://shopify/ProductVariant/49202074190142',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/49202074190142:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 49,
    variantId: '49202074190142',
    shopifyVariantId: 'gid://shopify/ProductVariant/49202074190142',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/49202074190142:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 69,
    variantId: '40200381038688',
    shopifyVariantId: 'gid://shopify/ProductVariant/40200381038688',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/40200381038688:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 212,
  },
  [ShopifyStore.MX]: {
    price: 899,
  },
  [ShopifyStore.ZA]: {
    price: 999,
  },
  [ShopifyStore.JP]: {
    price: 4980,
  },
};

// Sizing Kit that is a seperte product to buy
export const SizingKitProductShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = {
  [ShopifyStore.IN]: {
    price: 69,
    variantId: '42144169787462',
    shopifyVariantId: 'gid://shopify/ProductVariant/42144169787462',
    checkoutUrl:
      'https://ultrahumanstore.myshopify.com/cart/42144169787462:1?channel=buy_button',
  },
  [ShopifyStore.ROW]: {
    price: 1,
    variantId: '42163237027900',
    shopifyVariantId: 'gid://shopify/ProductVariant/42163237027900',
    checkoutUrl:
      'https://ultrahuman-us.myshopify.com/cart/42163237027900:1?channel=buy_button',
  },
  [ShopifyStore.US]: {
    price: 1,
    variantId: '40200422948960',
    shopifyVariantId: 'gid://shopify/ProductVariant/40200422948960',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/40200422948960:1?channel=buy_button',
  },
  [ShopifyStore.AE]: {
    price: 1,
    variantId: '46813981573362',
    shopifyVariantId: 'gid://shopify/ProductVariant/46813981573362',
    checkoutUrl:
      'https://ultrahuman-mena.myshopify.com/cart/46813981573362:1?channel=buy_button',
  },
  [ShopifyStore.EU]: {
    price: 1,
    variantId: '50364139635006',
    shopifyVariantId: 'gid://shopify/ProductVariant/50364139635006',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50364139635006:1?channel=buy_button',
  },
  [ShopifyStore.GB]: {
    price: 1,
    variantId: '50364139635006',
    shopifyVariantId: 'gid://shopify/ProductVariant/50364139635006',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50364139635006:1?channel=buy_button',
  },
  [ShopifyStore.AU]: {
    price: 1,
    variantId: '50364139635006',
    shopifyVariantId: 'gid://shopify/ProductVariant/50364139635006',
    checkoutUrl:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50364139635006:1?channel=buy_button',
  },
  [ShopifyStore.CA]: {
    price: 1,
    variantId: '40200422948960',
    shopifyVariantId: 'gid://shopify/ProductVariant/40200422948960',
    checkoutUrl:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/40200422948960:1?channel=buy_button',
  },
  [ShopifyStore.SA]: {
    price: 5,
  },
  [ShopifyStore.MX]: {
    price: 5,
  },
  [ShopifyStore.ZA]: {
    price: 1,
  },
  [ShopifyStore.JP]: {
    price: 2000,
  },
};

export const SizingKitShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? {
      [ShopifyStore.IN]: {
        variantId: '40666139033670',
        shopifyVariantId: 'gid://shopify/ProductVariant/40666139033670',
      },
      [ShopifyStore.AE]: {
        variantId: '44599427891442',
        shopifyVariantId: 'gid://shopify/ProductVariant/44599427891442',
      },
      [ShopifyStore.ROW]: {
        variantId: '40672441401404',
        shopifyVariantId: 'gid://shopify/ProductVariant/40672441401404',
      },
      [ShopifyStore.US]: {
        variantId: '39873251672160',
        shopifyVariantId: 'gid://shopify/ProductVariant/39873251672160',
      },
      [ShopifyStore.EU]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
      [ShopifyStore.GB]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
      [ShopifyStore.AU]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
      [ShopifyStore.CA]: {
        variantId: '39873251672160',
        shopifyVariantId: 'gid://shopify/ProductVariant/39873251672160',
      },
      [ShopifyStore.SA]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
      [ShopifyStore.MX]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
      [ShopifyStore.ZA]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
      [ShopifyStore.JP]: {
        variantId: '49202713493822',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202713493822',
      },
    }
  : {
      // Staging: every store hits uhtesting, so all share the free sizing kit
      // cloned from the IN store (product 15790525841481).
      [ShopifyStore.IN]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.AE]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.ROW]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.US]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.EU]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.GB]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.AU]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.CA]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.SA]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.MX]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.ZA]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
      [ShopifyStore.JP]: {
        variantId: '56102069403721',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102069403721',
      },
    };

/**
 * Ring PRO sizing kit (separate from Ring Air SizingKitShopifyMap).
 * Base stores only (IN, AE, ROW, US, EU); GB, AU, CA, SA, MX, ZA inherit via buildStoreConfig.
 * In staging, uses Ring Air SizingKitProductShopifyMap so the full flow can be tested.
 */
export const RingProSizingKitShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 0,
        variantId: '44694523871302',
        shopifyVariantId: 'gid://shopify/ProductVariant/44694523871302',
      },
      [ShopifyStore.AE]: {
        price: 0,
        variantId: '62576898212211',
        shopifyVariantId: 'gid://shopify/ProductVariant/62576898212211',
      },
      [ShopifyStore.ROW]: {
        price: 0,
        variantId: '44022056517692',
        shopifyVariantId: 'gid://shopify/ProductVariant/44022056517692',
      },
      [ShopifyStore.US]: {
        price: 0,
        variantId: '42613973975136',
        shopifyVariantId: 'gid://shopify/ProductVariant/42613973975136',
      },
      [ShopifyStore.EU]: {
        price: 0,
        variantId: '57376060440950',
        shopifyVariantId: 'gid://shopify/ProductVariant/57376060440950',
      },
      [ShopifyStore.GB]: { price: 0 },
      [ShopifyStore.AU]: { price: 0 },
      [ShopifyStore.CA]: { price: 0 },
      [ShopifyStore.SA]: { price: 0 },
      [ShopifyStore.MX]: { price: 0 },
      [ShopifyStore.ZA]: { price: 0 },
      [ShopifyStore.JP]: { price: 0 },
    })
  : RingAirSizingKitProductShopifyMap;

export const EngravingShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? {
      [ShopifyStore.IN]: {
        price: 3_299,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.AE]: {
        price: 149,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.ROW]: {
        price: 39,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.US]: {
        price: 39,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.EU]: {
        price: 28,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.GB]: {
        price: 28,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.AU]: {
        price: 59,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.CA]: {
        price: 54,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.SA]: { price: 169 },
      [ShopifyStore.MX]: { price: 728 },
      [ShopifyStore.ZA]: { price: 999 },
      [ShopifyStore.JP]: {
        price: 6000,
        variantId: '',
        shopifyVariantId: '',
      },
    }
  : {
      [ShopifyStore.IN]: {
        price: 3_299,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.AE]: {
        price: 149,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.ROW]: {
        price: 39,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.US]: {
        price: 39,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.EU]: {
        price: 28,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.GB]: {
        price: 28,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.AU]: {
        price: 59,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.CA]: {
        price: 54,
        variantId: '',
        shopifyVariantId: '',
      },
      [ShopifyStore.SA]: { price: 169 },
      [ShopifyStore.MX]: { price: 728 },
      [ShopifyStore.ZA]: { price: 999 },
      [ShopifyStore.JP]: {
        price: 6000,
        variantId: '',
        shopifyVariantId: '',
      },
    };

export const RingAndRelatedProductsIdMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: [
          'gid://shopify/Product/7181298532422', // engraved
          'gid://shopify/Product/7129411813446', // not engraved
          'gid://shopify/Product/7521922023494', // travel moon
          'gid://shopify/Product/7148985712710', // sizing kit
        ],
        [ShopifyStore.AE]: [
          'gid://shopify/Product/7948546998514', // engraved
          'gid://shopify/Product/7918333264114', // not engraved
          'gid://shopify/Product/8379290517746', // travel moon
          'gid://shopify/Product/7931770077426', // sizing kit
        ],
        [ShopifyStore.ROW]: [
          'gid://shopify/Product/7156336754748', // engraved
          'gid://shopify/Product/7129411813446', // not engraved
          'gid://shopify/Product/7129625821244', // us store ring (not eng)
          'gid://shopify/Product/7535317614652', // travel moon
          'gid://shopify/Product/7142706905148', // sizig kit
        ],
        [ShopifyStore.US]: [
          //change
          'gid://shopify/Product/6854366888032', // engraved
          'gid://shopify/Product/6853766807648', // not engraved
          'gid://shopify/Product/6853766807648', // us store ring (not eng)
          'gid://shopify/Product/7037398876256', // travel moon
          'gid://shopify/Product/6718282661984', // sizig kit
        ],
        [ShopifyStore.EU]: [
          //change
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
        [ShopifyStore.GB]: [
          //change
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
        [ShopifyStore.AU]: [
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
        [ShopifyStore.CA]: [
          'gid://shopify/Product/6854366888032', // engraved
          'gid://shopify/Product/6853766807648', // not engraved
          'gid://shopify/Product/6853766807648', // us store ring (not eng)
          'gid://shopify/Product/7037398876256', // travel moon
          'gid://shopify/Product/6718282661984', // sizig kit
        ],
        [ShopifyStore.SA]: [
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
        [ShopifyStore.MX]: [
          //change
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
        [ShopifyStore.ZA]: [
          //change
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
        [ShopifyStore.JP]: [
          //change
          'gid://shopify/Product/10950659113278', // engraved
          'gid://shopify/Product/10950629359934', // not engraved
          'gid://shopify/Product/10950659014974', // sizig kit
        ],
      }
    : {
        // Staging routes every store to uhtesting: cloned IN Ring AIR products.
        [ShopifyStore.IN]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.AE]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.ROW]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.US]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.EU]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.GB]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.AU]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.CA]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.SA]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.MX]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.ZA]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
        [ShopifyStore.JP]: [
          'gid://shopify/Product/15790525677641', // engraved
          'gid://shopify/Product/15790525546569', // not engraved
          'gid://shopify/Product/6914118320201', // dark moon
          'gid://shopify/Product/15790525841481', // sizing kit
        ],
      };

export const AfibCountryCodes = [
  'GB', // United Kingdom
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Republic of Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'CH', // Switzerland
  'TR', // Turkey
  'AL', // Albania
  'DZ', // Algeria
  'AD', // Andorra
  'AO', // Angola
  'AG', // Antigua And Barbuda
  'AM', // Armenia
  'AU', // Australia
  'AZ', // Azerbaijan
  'BS', // Bahamas
  'BH', // Bahrain
  'BD', // Bangladesh
  'BB', // Barbados
  'BZ', // Belize
  'BJ', // Benin
  'BT', // Bhutan
  'BW', // Botswana
  'BN', // Brunei Darussalam
  'BF', // Burkina Faso
  'BI', // Burundi
  'CM', // Cameroon
  'CV', // Cape Verde
  'TD', // Chad
  'KM', // Comoros
  'CG', // Congo
  'CI', // Cote D'Ivoire
  'DJ', // Djibouti
  'DM', // Dominica
  'DO', // Dominican Republic
  'SV', // El Salvador
  'GQ', // Equatorial Guinea
  'ER', // Eritrea
  'FJ', // Fiji
  'GA', // Gabon
  'GM', // Gambia
  'GE', // Georgia
  'GD', // Grenada
  'GT', // Guatemala
  'GN', // Guinea
  'GW', // Guinea-Bissau
  'GY', // Guyana
  'HT', // Haiti
  'HK', // Hong Kong
  'JM', // Jamaica
  'KI', // Kiribati
  'KW', // Kuwait
  'LA', // Lao People's Democratic Republic
  'LS', // Lesotho
  'LR', // Liberia
  'MO', // Macao
  'MG', // Madagascar
  'MW', // Malawi
  'MV', // Maldives
  'MH', // Marshall Islands
  'MR', // Mauritania
  'MU', // Mauritius
  'FM', // Micronesia, Federated States Of
  'MD', // Moldova, Republic Of
  'MN', // Mongolia
  'MZ', // Mozambique
  'NA', // Namibia
  'NR', // Nauru
  'NP', // Nepal
  'NE', // Niger
  'PK', // Pakistan
  'PW', // Palau
  'PG', // Papua New Guinea
  'QA', // Qatar
  'RW', // Rwanda
  'KN', // Saint Kitts And Nevis
  'LC', // Saint Lucia
  'VC', // Saint Vincent And The Grenadines
  'ST', // Sao Tome And Principe
  'SA', // Saudi Arabia
  'SN', // Senegal
  'SC', // Seychelles
  'SL', // Sierra Leone
  'SG', // Singapore
  'SR', // Suriname
  'SZ', // Swaziland (now Eswatini)
  'TL', // Timor-Leste
  'TG', // Togo
  'TO', // Tonga
  'TT', // Trinidad And Tobago
  'TM', // Turkmenistan
  'TV', // Tuvalu
  'UG', // Uganda
  'AE', // United Arab Emirates
  'VU', // Vanuatu
  'EH', // Western Sahara
  'ZM', // Zambia
  'ZW', // Zimbabwe
];
